type Props = {
  size?: number;
  withWordmark?: boolean;
  className?: string;
};

export function Logo({ size = 32, withWordmark = false, className }: Props) {
  if (withWordmark) {
    return (
      <div className={`inline-flex items-center gap-2.5 ${className ?? ""}`}>
        <Mark size={size} />
        <span className="font-display font-semibold tracking-tighter text-neutral-0" style={{ fontSize: size * 0.75 }}>
          Sportal
        </span>
      </div>
    );
  }
  return <Mark size={size} className={className} />;
}

function Mark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="Sportal"
      className={className}
    >
      <rect x="2" y="2" width="28" height="28" rx="7" fill="#3d9d6e" />
      <path
        d="M6.5 16.5 C 10 9, 22 9, 25.5 16.5"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="21" cy="22.5" r="4.2" fill="#ffffff" />
    </svg>
  );
}
